import { Truck, Car, Settings } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import VehicleTypesManager from './systems/VehicleTypesManager';

const SystemsPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-primary/10">
          <Truck className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-3xl font-bold">Configurações FleetONE</h1>
          <p className="text-muted-foreground">
            Tipos de veículos e configurações gerais do sistema
          </p>
        </div>
      </div>

      <Tabs defaultValue="vehicle-types" className="space-y-4">
        <TabsList>
          <TabsTrigger value="vehicle-types" className="flex items-center gap-2">
            <Car className="h-4 w-4" />
            Tipos de Veículos
          </TabsTrigger>
          <TabsTrigger value="general" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Configurações Gerais
          </TabsTrigger>
        </TabsList>

        {/* Tipos de Veículos */}
        <TabsContent value="vehicle-types">
          <VehicleTypesManager />
        </TabsContent>

        {/* Configurações Gerais */}
        <TabsContent value="general">
          <Card>
            <CardHeader>
              <CardTitle>Configurações Gerais do FleetONE</CardTitle>
              <CardDescription>
                Configurações globais aplicáveis a todas as empresas
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Funcionalidades futuras: intervalos de manutenção padrão, 
                tipos de alertas globais, templates de relatórios, etc.
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SystemsPage;
